

import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthContext, AuthProvider } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import Navbar from './components/Navbar';

const App = () => {
  const { authToken, logout } = useContext(AuthContext);

  return (
    <Router>
      {authToken && <Navbar logout={logout} />}
      <Routes>
        <Route path="/login" element={authToken ? <Navigate to="/" /> : <LoginPage />} />
        <Route path="/" element={authToken ? <HomePage /> : <Navigate to="/login" />} />
      </Routes>
    </Router>
  );
};

const AppWrapper = () => (
  <AuthProvider>
    <App />
  </AuthProvider>
);

export default AppWrapper;

